import { Box, Button } from "@drone-js/core";
import { useUrlBuilder } from "apps/commons/hooks/useUrlBuilder";
import { LanguageSwitcher } from "libs/languageSwitcher";
import type { FunctionComponent } from "react";
import { useParams } from "router";
import { usePartnerMarketingModelValue } from "./partnerMarketingModelAtom";
import { usePassedPropertyWizardSectionValue } from "./passedPropertyWizardSectionAtom";

const ListYourPlaceButton: FunctionComponent = () => {
    const {
        heroSectionViewModel: { listMyPropertyText },
    } = usePartnerMarketingModelValue();
    const isPassedHeroSection = usePassedPropertyWizardSectionValue();
    const urlBuilder = useUrlBuilder();

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    if (!isPassedHeroSection) return null;

    return (
        <Box
            qM={{
                display: "flex",
            }}
            display="none"
        >
            <Button
                variant="label"
                hierarchy="primary"
                data-element-name="list-your-property"
                label={listMyPropertyText}
                onClick={scrollToTop}
                href={urlBuilder.onboardingUrl()}
            />
        </Box>
    );
};

const ULSigninButton: FunctionComponent = () => {
    const { isAuthenticated, signinText } = usePartnerMarketingModelValue();
    const urlBuilder = useUrlBuilder();

    if (isAuthenticated) return null;

    return (
        <Button
            hierarchy="secondary"
            variant="label"
            href={urlBuilder.signInUrl()}
            label={signinText}
            data-element-name="sign-in"
            size="l"
        />
    );
};

export const Navbar: FunctionComponent = () => {
    const atom = usePartnerMarketingModelValue();
    const { lang } = useParams("/:lang/list-my-property");

    return (
        <nav>
            <div className="ncon">
                <a href={`https://agoda.com/${lang}`}>
                    <img
                        className="logo"
                        loading="eager"
                        alt="Agoda"
                        src="https://cdn6.agoda.net/images/kite-js/logo/agoda/color-default.svg"
                    />
                </a>
                <Box display="flex" gap="24">
                    {atom !== undefined && (
                        <>
                            <ULSigninButton />
                            <ListYourPlaceButton data-test-id="list-your-place-button" />
                        </>
                    )}
                    <LanguageSwitcher
                        languageFlagElementName="select-language"
                        languageFlagSelectorElementName="language-selector-link"
                    />
                </Box>
            </div>
        </nav>
    );
};
